// @flow
import * as React from 'react';
import styled from 'styled-components';
import ReactSlider from 'react-slider';
import BarImage from 'assets/images/icons/slider_thumb_bar.svg';

type Props = {
  initialValue?: number,
  onChange?: (number) => void,
}

export default function HueSlider(props: Props): React.Element<any> {
  const [step, setStep] = React.useState((props.initialValue ?? 0) * 100);
  //{ a: 1, h: data.h, l: 0.5, s: 1 }

  const rgb: Array<number> = React.useMemo(() => {
    return hslToRgb(step * 0.01, 1, 0.5)
  }, [step]);

  const handleChangeStep = React.useCallback((value) => {
    setStep(value);
    props.onChange?.(value * 0.01);
  }, [props]);

  const handleChangeGauge = React.useCallback((value) => {
    setStep(value);
    props.onChange?.(value * 0.01);
  }, [props]);

  return <StyledSlider
    value={step}
    //marks={[10, 20, 100]}
    //step={100}
    renderTrack={(props, state) => <Track {...props} dataIndex={state.index} />}
    renderThumb={(props, state) => <StyledThumb {...props} dataColor={rgbToHex(rgb[0], rgb[1], rgb[2])}><img src={BarImage} alt="thumb bar" /></StyledThumb>}
    onChange={val => handleChangeStep(val)}
    onAfterChange={val => handleChangeGauge(val)}
   />
}

/**
 * Converts an HSL color value to RGB. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes h, s, and l are contained in the set [0, 1] and
 * returns r, g, and b in the set [0, 255].
 *
 * @param   {number}  h       The hue
 * @param   {number}  s       The saturation
 * @param   {number}  l       The lightness
 * @return  {Array}           The RGB representation
 */
 function hslToRgb(h: number, s: number, l: number): Array<number> {
  var r, g, b;

  if(s === 0){
      r = g = b = l; // achromatic
  }else{
      var hue2rgb = function hue2rgb(p: number, q: number, t: number){
          if(t < 0) t += 1;
          if(t > 1) t -= 1;
          if(t < 1/6) return p + (q - p) * 6 * t;
          if(t < 1/2) return q;
          if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
          return p;
      }

      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hue2rgb(p, q, h + 1/3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1/3);
  }

  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}

function componentToHex(c: number): string {
  var hex = c.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

function rgbToHex(r:number, g: number, b: number): string {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

const StyledTrack = styled.div`
  top: -1.5px;
  bottom: 0px;
`;

const Track = (props: any, state: any) => <StyledTrack {...props} index={state.index}></StyledTrack>

const StyledSlider = styled(ReactSlider)`
  width: ${(props: any) => (props.theme.layout.sizeL ? 320 : 240)}px;
  height: ${(props: any) => (props.theme.layout.sizeL ? 6 : 4)}px;

  background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0
                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
  background: -webkit-linear-gradient(to right, #f00 0%, #ff0
    17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);

  border-radius: 10px;
`;

const StyledThumb = styled.div`
  position: relative;
  top: ${(props: any) => (props.theme.layout.sizeL ? -12 + 3 : -9 + 2)}px;
  width: ${(props: any) => (props.theme.layout.sizeL ? 24 : 18)}px;
  height: ${(props: any) => (props.theme.layout.sizeL ? 24 : 18)}px;
  outline:none;
  cursor: grab;

  box-sizing: border-box;
  border-radius: 50%;
  background-color: ${(props: any) => props.dataColor};
  pointer-events: auto;

  display: flex;
  align-items: center;
  justify-content: center;

  > img {
    width: ${(props: any) => props.theme.layout.sizeL ? 8 : 6}px;
  }
`;
